/**
 * blank - is a custom SVG Icon that displays when an icon is hidden in the Actions Column of the Grid.
 */
import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const Blank = createSvgIcon(
  <>
    <defs id="defs2" />
    <g id="layer1">
      <rect y="0" x="0" height="4.2333331" width="4.2333331" id="rect10" style={{ fill: 'none', strokeWidth: '0.0560033' }} />
    </g>
  </>,
  'Blank'
);
